import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Global from '../../../../store/global-selectors';
import { emptyArray } from 'ui-components/default-props/empty';
import PrintDocumentButton from '../../../../components/print-document-button';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { FormattedMessage } from 'react-intl';
import { DocumentType } from '../../../../enums/document-type';
import {
  printLabelRequest,
  batchPrintOtherForms,
  startPackingSlipPrintedStatusCheck,
} from '../../../../store/batches/print/batches.print.actions';
import { checkDoesBatchHaveOtherForms } from '../../../../store/batches/batches.api';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import {
  labelQuePrintOrderSummary,
  labelQuePrintPickListStart,
  labelQuePrintShipmentManifestStart,
} from '../../../../store/label-que/label-que.actions';

const NO_BATCH_SELECTED = 'NO_BATCH_SELECTED';

const PrintDocumentButtonComponent = () => {
  const dispatch = useDispatch();
  const selectedBatches = useSelector(Global.selectBatchesSelectedBatches) || emptyArray;
  const userHasShippingRole = useSelector(Global.selectUserhasShippingRole);
  const isDisabled = selectedBatches.length !== 1;
  const selectedFulfillmentPlanSetId = !isDisabled ? selectedBatches[0].fulfillmentPlanSetId : NO_BATCH_SELECTED;
  const [hasOtherFormDocs, setHasOtherFormDocs] = useAsyncSafeState(false);

  const checkHasOtherForms = useCallback(async () => {
    const { data } = await checkDoesBatchHaveOtherForms(selectedFulfillmentPlanSetId);
    const { hasOtherForms } = data;
    setHasOtherFormDocs(hasOtherForms);
  }, [selectedFulfillmentPlanSetId, setHasOtherFormDocs]);

  useEffect(() => {
    if (selectedFulfillmentPlanSetId === NO_BATCH_SELECTED) {
      return;
    }
    checkHasOtherForms();
  }, [checkHasOtherForms, selectedFulfillmentPlanSetId]);

  const onPrintPackingSlip = useCallback(() => {
    dispatch(startPackingSlipPrintedStatusCheck([selectedFulfillmentPlanSetId]));
  }, [dispatch, selectedFulfillmentPlanSetId]);

  const onPrintLabel = useCallback(() => {
    dispatch(printLabelRequest([selectedFulfillmentPlanSetId]));
  }, [dispatch, selectedFulfillmentPlanSetId]);

  const onPrintOrderSummary = useCallback(() => {
    dispatch(labelQuePrintOrderSummary(selectedFulfillmentPlanSetId));
  }, [dispatch, selectedFulfillmentPlanSetId]);

  const onPrintPickList = useCallback(() => {
    dispatch(labelQuePrintPickListStart(selectedFulfillmentPlanSetId));
  }, [dispatch, selectedFulfillmentPlanSetId]);

  const onPrintShipmentManifest = useCallback(() => {
    dispatch(labelQuePrintShipmentManifestStart(selectedFulfillmentPlanSetId));
  }, [dispatch, selectedFulfillmentPlanSetId]);

  const onPrintOtherForms = useCallback(() => {
    dispatch(batchPrintOtherForms(selectedFulfillmentPlanSetId));
  }, [dispatch, selectedFulfillmentPlanSetId]);

  return (
    <PrintDocumentButton disabled={isDisabled} theme='tertiary'>
      <DropdownMenuItem disabled={!userHasShippingRole} onClick={onPrintLabel}>
        <FormattedMessage {...DocumentType.Label.documentNameTranslation} />
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onPrintPackingSlip}>
        <FormattedMessage {...DocumentType.PackingSlip.documentNameTranslation} />
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onPrintOrderSummary}>
        <FormattedMessage {...DocumentType.OrderSummary.documentNameTranslation} />
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onPrintPickList}>
        <FormattedMessage {...DocumentType.PickList.documentNameTranslation} />
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onPrintShipmentManifest}>
        <FormattedMessage {...DocumentType.ShipmentManifest.documentNameTranslation} />
      </DropdownMenuItem>
      <DropdownMenuItem disabled={!hasOtherFormDocs} onClick={onPrintOtherForms}>
        <FormattedMessage {...DocumentType.OtherForms.documentNameTranslation} />
      </DropdownMenuItem>
    </PrintDocumentButton>
  );
};

export default PrintDocumentButtonComponent;
